import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Button, Card, CardTitle, Field, Input } from '@/ui/primitives';
import { Stack } from '@/ui/layout';
import type { User } from '@/lib/auth';
import { profileUpdateSchema, type ProfileUpdateInput } from '../schemas';
import { useUpdateProfile } from '../api';

interface Props {
  user: User;
}

export function DadosPessoaisForm({ user }: Props) {
  const mutation = useUpdateProfile(user.id);

  const form = useForm<ProfileUpdateInput>({
    resolver: zodResolver(profileUpdateSchema),
    defaultValues: {
      name: user.name,
      cargo: user.cargo ?? '',
      ...(user.avatar_color ? { avatar_color: user.avatar_color as ProfileUpdateInput['avatar_color'] } : {}),
    },
  });

  const onSubmit = form.handleSubmit((values) => {
    mutation.mutate(values, {
      onSuccess: () => form.reset(values),
    });
  });

  return (
    <Card padding="lg">
      <form onSubmit={onSubmit} className="flex flex-col gap-4">
        <CardTitle>Dados pessoais</CardTitle>
        <Stack gap="md">
          <Field
            label="Nome completo"
            htmlFor="perfil-nome"
            error={form.formState.errors.name?.message}
            required
          >
            <Input
              id="perfil-nome"
              invalid={!!form.formState.errors.name}
              {...form.register('name')}
            />
          </Field>
          <Field label="Cargo" htmlFor="perfil-cargo" error={form.formState.errors.cargo?.message}>
            <Input
              id="perfil-cargo"
              placeholder="Ex.: Analista jurídico"
              {...form.register('cargo')}
            />
          </Field>
          <Field label="E-mail" htmlFor="perfil-email" hint="O e-mail não pode ser alterado">
            <Input id="perfil-email" type="email" value={user.email} disabled />
          </Field>
        </Stack>
        <div className="flex justify-end gap-2">
          <Button
            type="submit"
            variant="primary"
            disabled={mutation.isPending || !form.formState.isDirty}
          >
            {mutation.isPending ? 'Salvando…' : 'Salvar alterações'}
          </Button>
        </div>
      </form>
    </Card>
  );
}
